import { useState } from "react";
import {
  Button,
  Dialog,
  DialogContent,
  CardHeader,
  CardContent,
  CardActions,
  TextField,
  Grid,
  Typography,
} from "../../../../../components";
import { notification, MdfeService } from "../../../../../services";
import { responseErros } from "../../../../../utils";
import { MdfeCancelamento } from "../../entities";

const CancelamentoDialog = ({ open, setOpen, setLoading, id, buscarMdfe }) => {
  const [justificativa, setJustificativa] = useState(null);
  const mdfeService = new MdfeService();

  const onSubmit = (event) => {
    event.preventDefault();
    cancelarMdfe();
  };

  const cancelarMdfe = async () => {
    setLoading(true);
    const mdfeCancelamento = new MdfeCancelamento(justificativa);
    const response = await mdfeService.cancelar(id, mdfeCancelamento);
    setLoading(false);
    if (!response.isAxiosError) {
      notification.alteracaoSucesso();
      await buscarMdfe();
      setOpen(false);
      return;
    }
    if (response.status != 400) {
      responseErros(response);
    }
  };

  return (
    <Dialog disableEscapeKeyDown maxWidth="md" fullWidth open={open}>
      <form onSubmit={(event) => onSubmit(event)}>
        <DialogContent>
          <CardHeader title="Digite a justificativa para o cancelamento" />
          <CardContent>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  id="justificativa"
                  name="justificativa"
                  label="Justificativa"
                  variant="outlined"
                  margin="normal"
                  onChange={(event) => setJustificativa(event.target.value)}
                  value={justificativa}
                  required
                  fullWidth
                />
                <Grid item xs={12} className="d-flex justify-content-between">
                  <Typography style={{ color: "#DC3545" }}>
                    Quantidade mínima de 15 caracteres
                  </Typography>
                  <Typography>
                    N° de caracteres: {justificativa?.length || 0}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
          <CardActions>
            <Button variant="contained" color="primary" type="submit">
              <i
                className="ph-fill ph-check-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Cancelar MDFE
            </Button>
            <Button
              variant="contained"
              color="padrao"
              onClick={() => setOpen(false)}
            >
              <i
                className="ph-fill ph-x-circle"
                style={{ fontSize: 22, marginRight: 10 }}
              ></i>
              Fechar
            </Button>
          </CardActions>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default CancelamentoDialog;
